import React, {useEffect, useState, useRef, Fragment} from 'react';
import ReactDOM from 'react-dom';
import {Loader} from '../../../components';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Add_data from './Add_data';
import List_view from './View';
import axios from 'axios';

export default function List(props) {
    const[empty, setEmpty]=useState(false);


    if(empty==false){
      return(<List_view type='company' {...props} countries={props.countries} setEmpty={setEmpty}/>)
    }else{
      let elements=(data.type=='company')?'Add companies':(data.type=='contact')?'Add contacts':'';
      return(
        <div style={{width:'100vw', marginTop:'70px', display:'flex', justifyContent:'center', alignItems:'center'}}>
          <Add_data title={elements} button={elements} list_id={props.match.params.list}/>
        </div>
    )
    }
}
